/**
 * External dependencies
 */
import { get } from 'lodash';

export default (state, id) => get(state, ['connectionWebhooks', 'items', id], null);